// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import FormStructureData = App.Data.FormStructureData;
import GetFormStructureResponse = App.Http.Responses.FormStructure.GetFormStructureResponse;
import StoreFormStructureRequest = App.Http.Requests.FormStructure.StoreFormStructureRequest;
import GetFormStructuresRequest = App.Http.Requests.FormStructure.GetFormStructuresRequest;
import GetFormStructuresResponse = App.Http.Responses.FormStructure.GetFormStructuresResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class FormStructureApi extends TenantBaseApi {
    /**
     * Get list of form objects
     *
     * - Request: GetFormStructuresRequest
     * - Response: GetFormStructuresResponse
     */
    async index(request: GetFormStructuresRequest): Promise<GetFormStructuresResponse> {
        return await this.get<GetFormStructuresResponse, GetFormStructuresRequest>("/form-structures", {
            params: request,
        });
    }

    /**
     * Get specific form object
     *
     * - Request: any (optional)
     * - Response: GetFormStructureResponse
     */
    async show(formStructureId: string, request?: unknown): Promise<GetFormStructureResponse> {
        return await this.get<GetFormStructureResponse, unknown>(`/form-structures/${formStructureId}`, {
            params: request,
        });
    }

    /**
     * Store form object
     *
     * - Request: StoreFormStructureRequest
     * - Response: GetFormStructureResponse
     */
    async store(request: StoreFormStructureRequest): Promise<GetFormStructureResponse> {
        return await this.post<GetFormStructureResponse, StoreFormStructureRequest>("/form-structures", request);
    }

    /**
     * Update form object
     *
     * - Request: StoreFormStructureRequest
     * - Response: GetFormStructureResponse
     */
    async update(request: StoreFormStructureRequest, formStructureId: string): Promise<GetFormStructureResponse> {
        return await this.put<GetFormStructureResponse, StoreFormStructureRequest>(
            `/form-structures/${formStructureId}`,
            request
        );
    }

    /**
     * Delete form object
     *
     * - Request: FormStructureData
     * - Response: void
     */
    async destroy(formStructure: FormStructureData): Promise<void> {
        return await this.delete<void>(`/form-structures/${formStructure.id}`);
    }

    async export(request: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/form-structures/export", request);
    }
}

export const formStructureApi = new FormStructureApi();
